import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getSessionData } from '../utils/storageUtils';

export function useAuth() {
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    // Lógica de verificação e redirecionamento removida daqui.
    // A verificação agora é feita apenas em mainPage.tsx.
    
    // console.log("useAuth hook running on path:", location.pathname);
    // Pode adicionar aqui outra lógica relacionada à autenticação, se necessário no futuro.

  }, [navigate, location.pathname]);
} 